<script lang="ts" setup>
  import { onMounted, useTemplateRef } from 'vue';
  import { InputField } from '../../../shared/ui/input-field';

  defineProps<{ error?: string; placeholder: string }>();
  const model = defineModel<string>();

  const inputRef = useTemplateRef<HTMLInputElement>('input');

  onMounted(() => {
    inputRef.value?.focus();
  });
</script>

<template>
  <InputField v-slot="field" :error>
    <input
      ref="input"
      v-model="model"
      v-bind="field"
      :placeholder="$props.placeholder"
      aria-label="Nickname"
      enterkeyhint="go"
    />
  </InputField>
</template>

<style scoped>
  input {
    border: 1px solid var(--color-border-strong);
    border-radius: var(--radius-control);
    font-size: var(--font-size-lg);
    height: 3rem;
    max-width: var(--control-max-width);
    text-align: center;
    width: 100%;

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }

    &[aria-invalid='true'] {
      border-color: var(--color-error);
    }
  }
</style>
